<template>
    <table v-if="locations" class="table table-striped">
        <thead>
            <tr>
                <th scope="col"></th>
                <th scope="col">Name</th>
                <th scope="col">Price</th>
                <th scope="col">Rating</th>
                <th scope="col">Reviews</th>
            </tr>
        </thead>
        <tbody>
            <tr v-for="location in locations" :key="location.id">
                <td>
                    <a :href="location.url" target="blank">
                        <img :src="location.image_url" width="75" height="75">
                    </a>
                <td>
                    <a :href="location.url" target="blank">
                        <strong>{{ location.name }}</strong>
                    </a>
                    <br />
                    <span v-for="(category, index) in location.categories" :key="index">
                        {{ category }}<span v-if="index + 1 < location.categories.length">,</span>
                    </span>
                </td>
                <td>{{ location.price }}</td>
                <td>{{ location.rating }}</td>
                <td>{{ location.reviews.toLocaleString() }}</td>
            </tr>
        </tbody>
    </table>
</template>

<script>
export default {
  name: 'Locations',
  props: {
    locations: Array
  }
}
</script>
